/**
 * The single source of truth for "what have we actually shipped".
 *
 * Every public Worker on a `karrtopelka.com` subdomain gets one entry here. The hub's
 * `/subdomains` page renders this list and pings each `origin` for a live status dot,
 * so adding a row is the only step needed to make a new deploy show up in the index.
 *
 * Private surfaces (hq, auth) are deliberately absent — the index is public.
 */

export type SiteKind = "game" | "apex";

export interface SiteDef {
  /** Worker/app directory name — also the leaderboard `game` key for kind "game". */
  id: string;
  /** Subdomain label as shown in the index ("aim", or "@" for the apex). */
  label: string;
  origin: string;
  kind: SiteKind;
  /** One line, lowercase, no period — matches the hub's voice. */
  blurb: string;
  /** ISO date the subdomain first went live. Drives the "shipped" column ordering. */
  since: string;
}

export const SITES: SiteDef[] = [
  {
    id: "hub",
    label: "@",
    origin: "https://karrtopelka.com",
    kind: "apex",
    blurb: "the front door — every game, every leader",
    since: "2026-06-09",
  },
  {
    id: "reflex",
    label: "reflex",
    origin: "https://reflex.karrtopelka.com",
    kind: "game",
    blurb: "five taps, one reaction time",
    since: "2026-06-09",
  },
  {
    id: "wheel",
    label: "wheel",
    origin: "https://wheel.karrtopelka.com",
    kind: "game",
    blurb: "push your luck, grow the streak",
    since: "2026-06-10",
  },
  {
    id: "aim",
    label: "aim",
    origin: "https://aim.karrtopelka.com",
    kind: "game",
    blurb: "twenty seconds of targets",
    since: "2026-06-10",
  },
  {
    id: "crash",
    label: "crash",
    origin: "https://crash.karrtopelka.com",
    kind: "game",
    blurb: "cash out before the curve breaks",
    since: "2026-06-11",
  },
  {
    id: "stop",
    label: "stop",
    origin: "https://stop.karrtopelka.com",
    kind: "game",
    blurb: "hit 5.00s blind",
    since: "2026-06-11",
  },
  {
    id: "mines",
    label: "mines",
    origin: "https://mines.karrtopelka.com",
    kind: "game",
    blurb: "gems, four mines, know when to stop",
    since: "2026-07-05",
  },
  {
    id: "limbo",
    label: "limbo",
    origin: "https://limbo.karrtopelka.com",
    kind: "game",
    blurb: "call the multiplier, let the dice answer",
    since: "2026-07-05",
  },
  {
    id: "plinko",
    label: "plinko",
    origin: "https://plinko.karrtopelka.com",
    kind: "game",
    blurb: "one ball, twelve rows, 175x edges",
    since: "2026-07-05",
  },
  {
    id: "draw",
    label: "draw",
    origin: "https://draw.karrtopelka.com",
    kind: "game",
    blurb: "one shared reveal at 19:00 utc",
    since: "2026-06-12",
  },
  {
    id: "rocket",
    label: "rocket",
    origin: "https://rocket.karrtopelka.com",
    kind: "game",
    blurb: "everyone rides the same launch",
    since: "2026-06-12",
  },
];

export const GAME_SITES = SITES.filter((s) => s.kind === "game");
